import PropTypes from 'prop-types'
import { SourceLabel } from '../sourceLabel'
import classes from './index.module.scss'

export const Layout = ({ children }) => {
  return (
    <div className={classes.container}>
      <div className="h100 flexColumn">
        <div className="flex1">
          <div className="dFlex gap4 h100">{children}</div>
        </div>

        <SourceLabel />
      </div>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}
